export default __webpack_public_path__ + "static/media/refactor.76d9c181.png";